import React from "react";
import { TableCell, TableRow, TableHead } from "@mui/material";

const cellStyle = {
  fontWeight: "bold",
  color: "#333",
  backgroundColor: "#f5f5f5",
};

const TableHeader = () => (
  <TableHead>
    <TableRow>
      <TableCell sx={cellStyle}>Name</TableCell>
      <TableCell sx={cellStyle}>Description</TableCell>
      <TableCell sx={cellStyle}>Flavors</TableCell>
      <TableCell sx={cellStyle}>Size Options</TableCell>
      <TableCell sx={cellStyle}>Image</TableCell>
      <TableCell sx={cellStyle} align="right">
        Actions
      </TableCell>
    </TableRow>
  </TableHead>
);

export default TableHeader;
